import {
  setConfiguration,
  WidgetAfterSaveMethods,
} from "@configuratorware/configurator-frontendgui/App/configuration";
import Api from "@configuratorware/configurator-frontendgui/Framework/Api";
import Screen from "./App/Screens/Configurator/Screen";
import CustomDesignReducer from "./App/Reducers/CustomDesignReducer/Reducer";
import CustomCreatorReducer from "./App/Reducers/CustomCreatorReducer/Reducer";
// import CalculationWidget from './App/Screens/Configurator/Components/CalculationWidget';
import CustomConfigurationMode from "./App/Reducers/ConfigurationMode/Reducer";
import Services from "./App/Services/Services";
import CustomConfigurator from "./App/Reducers/Configurator/Reducer";
const prod = process.env.NODE_ENV === "production";

const domainRHM = process.env.DOMAIN_RHM;
// || (prod ? 'https://klio-eterna-rhm.sq2.ovh' : 'https://dev.klio-eterna-rhm.sq2.ovh');
// || (prod ? 'https://klio-eterna-rhm.sq2.ovh' : 'https://spiel-konf.klio.com');
// || (prod ? 'https://klio-eterna-rhm.sq2.ovh' : 'https://spiel-konf.klio.com');
const domainWebServer = process.env.DOMAIN_WEBSERVER;

const envDomains = {
  test: domainRHM,
  int: domainRHM,
  local: domainRHM,
  prod: domainRHM,
};
const webServerDomains = {
  test: domainWebServer,
  int: domainWebServer,
  local: domainWebServer,
  prod: domainWebServer,
};
const domain = envDomains[prod ? "prod" : "int"];

const query = new URLSearchParams(location.search);

const adminMode = query.get("_adminmode");

const customApplicationConfiguration = {
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}/media/`,
  },
  webserverDomain: webServerDomains[prod ? "prod" : "int"],

  showAddToCartButton: true,
  language: "de_DE",
  locales: [
    { code: "de_DE", preferred: true },
    { code: "en_GB" },
    { code: "fr_FR" },
  ],

  renderPreviewImagesForCheckout: false,
  // from docs:

  /*
    defaultLoadIdentifier: false,
    loadVariantsFirst: false,
    showInitialOptionclassification: false,
    showStartHere: true,
    showAddToCartButton: true,

    language: false,
    locales: [{ code: 'de_DE', preferred: true }, { code: 'en_GB' }],

   // saveTypes: SaveTypes,
   // customTitleSaveTypes: [SaveTypes.DESIGNTEMPLATE, SaveTypes.INSPIRATION],
    editCustomTitleBeforeSave: false,
    displayInspirations: false,

    availableTools: {
        fastConfiguration: false,
        save: true,
        load: true,
        share: true,
        print: true,
    },
    displayAcceptDesign: true,
    showAddToCartButton: true,
    validateBeforeAddToCart: false,
    dock: false,
    addToCartMethod: 'postMessage',
    restrictAmountselectionToSelectedVariant: false,
    displayColorAmountWarnings: true,
    displayEditorRulers: true,
    displayReceiveOfferForm: false,

    visualization: { designAreaHighlightBackgroundColor: 'transparent' },
    designer: { dpi: 300 },

    displaySwitchedOptions: false,
    checkOptionclassificationOnSelect: false,
    optionclassificationCarousel: true,
    disableBeforeunloadWarning: false,
    hideOptionListOnAwayClick: true,
    optionDetailsWithImage: false,
    fixedOptionlist: false,
    optionlistDialogPositioning: {
        left: [['left', 'right'], ['top', 'top']],
        bottom: [['center', 'center'], ['bottom', 'top']],
    },
    optionListFixedToLeft: true,

    reducers: {
    //    configurator: customConfiguratorReducer
    }, */
  displayNetPrices: true,
  displayReceiveOfferForm: false,
  screens: {
    Configurator: Screen,
    // CalculationWidget: CalculationWidget,
  },
  reducers: {
    customDesignerData: CustomDesignReducer,
    customCreatorData: CustomCreatorReducer,
    configurationMode: CustomConfigurationMode,
    customConfigurator: CustomConfigurator,
  },

  services: Services,
};

setConfiguration(customApplicationConfiguration);

if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader("no-cache");
}

export default customApplicationConfiguration;
